import { v4 as uuidv4 } from 'uuid';
import type { Animal, Feeding, Weight } from './types';

export function createDemoData(): { animals: Animal[]; feedings: Feeding[]; weights: Weight[] } {
    const now = Date.now();
    const oneHour = 60 * 60 * 1000;
    const oneDay = 24 * oneHour;

    // Create ONE sample animal
    const sampleKitten: Animal = {
        id: uuidv4(),
        name: 'Whiskers',
        notes: 'Sample foster - explore the app, then delete to start tracking your real fosters!',
        feedingIntervalHours: 2,
        createdAt: now - 14 * oneDay,
        updatedAt: now,
        status: 'active',
    };

    const animals = [sampleKitten];

    // Create a few recent feedings to show the tracking history
    const feedings: Feeding[] = [
        // Most recent feeding - 1h 15m ago
        {
            id: uuidv4(),
            animalId: sampleKitten.id,
            amountMl: 8,
            timestamp: now - 1.25 * oneHour,
            createdAt: now - 1.25 * oneHour,
            urinated: true,
            pooped: true,
            poopConsistency: 'normal',
            poopColor: 'brown',
        },
        // Previous feeding - 3h 30m ago
        {
            id: uuidv4(),
            animalId: sampleKitten.id,
            amountMl: 7,
            timestamp: now - 3.5 * oneHour,
            createdAt: now - 3.5 * oneHour,
            urinated: true,
            pooped: false,
            notes: 'Needed extra stimulation',
        },
        // Older feeding - 5h 45m ago
        {
            id: uuidv4(),
            animalId: sampleKitten.id,
            amountMl: 8,
            timestamp: now - 5.75 * oneHour,
            createdAt: now - 5.75 * oneHour,
            urinated: true,
            pooped: true,
            poopConsistency: 'soft',
            poopColor: 'yellow',
        },
    ];

    // Create a few weight records to show growth tracking
    const weights: Weight[] = [
        // Most recent weight
        {
            id: uuidv4(),
            animalId: sampleKitten.id,
            weightGrams: 285,
            timestamp: now - 2 * oneHour,
            createdAt: now - 2 * oneHour,
        },
        // Yesterday's weight
        {
            id: uuidv4(),
            animalId: sampleKitten.id,
            weightGrams: 278,
            timestamp: now - oneDay,
            createdAt: now - oneDay,
        },
        // Two days ago
        {
            id: uuidv4(),
            animalId: sampleKitten.id,
            weightGrams: 270,
            timestamp: now - 2 * oneDay,
            createdAt: now - 2 * oneDay,
        },
    ];

    return { animals, feedings, weights };
}